<template>
  <div v-bind:class="{none: filtering && !leads[0].some(lead=> lead.filterExcluded===false)}">
    <h5 style="margin:5px; font-weight: bold;">
      <span v-if="postponed">Postponed</span> Period {{periodId}}
    </h5>
    <h6 style="margin:10px 5px" v-if="leads[0].length<1">No leads found for this period</h6>
    <b-table-simple
      class="billing-table"
      style="margin-top: 20px; width: 100%; font-size: 14px"
      striped
      no-local-sorting
    >
      <b-thead v-if="leads[0].length>0">
        <b-th v-for="th in deductTableFields" :key="th.key">
          {{ th.label }}
        </b-th>
      </b-thead>
      <b-tbody>
        <b-tr v-for="(item, i) in leads[0]" v-bind:key="makeId(i, item.id)" v-bind:hidden="item.filterExcluded">
          <b-td>
            <input
              type="checkbox"
              v-bind:id="makeId(i, item.id)"
              v-bind:value="makeId(i, item.id)"
              v-bind:disabled="item.ftd===1 || item.postponed"
              v-model="leadsChecked"
              @click="check($event.target.value, periodId)">
          </b-td>
          <b-td>
            {{ item.broker_name }}
          </b-td>
          <b-td>
            {{ item.country_name }}
          </b-td>
          <b-td>
            {{ item.created_at}}
          </b-td>
          <b-td>
            {{ item.p1 }}
          </b-td>
<!--          <b-td></b-td>-->
          <b-td>
            {{ item.broker_status }}
          </b-td>
          <b-td>
            {{ item.email }}
          </b-td>
          <b-td>
            <span v-if="item.ftd">Yes</span>
            <span v-if="!item.ftd">No</span>
          </b-td>
        </b-tr>
      </b-tbody>
    </b-table-simple>
  </div>
</template>

<style scoped>
.none{
  display: none;
}
</style>

<script>
export default {
  name: 'deduct-table',
  props: {
    leads: [],
    leadsChecked: [],
    deductTableFields: [],
    periodId: undefined,
    filtering: false,
    postponed: 0,
  },
  methods: {
    check(value, value2) {
      this.$emit('click', value, value2);
    },
    makeId(i, id) {
      return id+'_'+i+'-'+this.periodId;
    }
  }
}
</script>

